import { FeatureRolloutModel } from 'api/models';
import { getApiUrl } from 'config/api-url';
import http from 'config/http';

export const getCanaryUserFeatures = async () => {
    const { data } = await http.get(`${getApiUrl()}/feature-rollouts`);

    return FeatureRolloutModel.fromObjectList(data);
};
